import { getApiUrl } from './apiConfig';

export const fetchStudentStats = async () => {
  try {
    const response = await fetch(getApiUrl('student-stats'));
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching student stats:', error);
    return null;
  }
};
